import { ManualWithholdStatuses } from "types";

const loadOptions = () => ({
	options: ManualWithholdStatuses.getOptions(),
	hasMore: false,
});

const manualWithholdColumn = () => ({
	name: "isManual",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Manual Withhold",
});

export default manualWithholdColumn;
